export default __webpack_public_path__ + "static/media/navbar-logo-bgg-b2.cf93e46a.svg";